import Component from 'gia/Component'
import render from '../components/render'
import stage from '../components/stage'
import _each from 'lodash.foreach'



class  Recruit extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)

    this.ref = {
        form: null,
        button: null,
        error: null
    }
  }


  mount() {

    //this.an = $('.an')
    

    this.ref.form.addEventListener("submit", (ev)=> {
      ev.preventDefault();
      $(this.ref.button).addClass('is-sending')

       const myForm = this.ref.form;
       const formData = new FormData(myForm);

      //var data = new FormData(this.ref.form);
      //this.ajax(this.ref.form.method, this.ref.form.action, data, this.success.bind(this), this.error.bind(this));

      fetch("/", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          body: new URLSearchParams(formData).toString(),
        })
        .then((e) => this.success(e))
        .catch((error) => this.error(error));


    });
  

  }

  unmount() {
    //console.log("Unmount Sticky!");



  }




    success(e) {
      if(e.ok) {
      this.ref.form.reset();
        $('.form-wrap').removeClass('is-visible')
        $('.success-wrap').addClass('is-visible')
      }
      else {
        this.error()
      }
    }

    error() {
      $('.form-wrap').removeClass('is-visible')
      $(this.ref.error).addClass('is-visible')
    }



}

module.exports = Recruit
